import incomeShareConstants from "../constants/incomeShareConstants";

const initialState: {
  newIncomeShare: any;
  incomeShare: any;
  specificIncomeShare: any[];
  specificIncomeShareSuccess: Boolean;
  editIncomeSharePending: Boolean;
  editIncomeShareSuccess: Boolean;
} = {
  newIncomeShare: null,
  incomeShare: null,
  specificIncomeShare: [],
  specificIncomeShareSuccess: false,
  editIncomeSharePending: false,
  editIncomeShareSuccess: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case incomeShareConstants.GET_INCOME_SHARE_SUCCESS:
      return {
        ...state,
        incomeShare: action.payload.data,
      };
    case incomeShareConstants.ADD_INCOME_SHARE_SUCCESS:
      return {
        ...state,
        newIncomeShare: action.payload,
      };
    case incomeShareConstants.SPECIFIC_INCOME_SHARE_REQUEST:
      return {
        ...state,
        specificIncomeShareSuccess: false,
      };
    case incomeShareConstants.SPECIFIC_INCOME_SHARE_SUCCESS:
      return {
        ...state,
        specificIncomeShareSuccess: true,
      };
    case incomeShareConstants.GET_SPECIFIC_INCOME_SUCCESS:
      return {
        ...state,
        specificIncomeShare: action.payload.data.results,
      };
    case incomeShareConstants.EDIT_INCOME_SHARE_REQUEST:
      return {
        ...state,
        editIncomeSharePending: true,
        editIncomeShareSuccess: false,
      };
    case incomeShareConstants.EDIT_INCOME_SHARE_SUCCESS:
      return {
        ...state,
        editIncomeSharePending: false,
        editIncomeShareSuccess: true,
      };
    case incomeShareConstants.RESET_INCOME_SHARE_REQUEST:
      return {
        ...state,
        incomeShare: null,
        specificIncomeShare: [],
      };
    default:
      return {
        ...state,
      };
  }
};
